<div class="custom-table" #filterTableDiv>
  <!-- Any div or element addition affect function hideDefaultSearchBar() from utils.ts -->
  <table datatable class="table-bordered table-striped display nowrap hover" [dtOptions]="dtOptions" [dtTrigger]="dtTrigger" #table>
      <thead style="background-color: rgb(187 189 191 / 20%);">
        <!-- <tr #searchRow>
            <th scope="col" *ngFor="let head of dtOptions.columns"></th>
        </tr> -->
        <tr>
            <th scope="col" class="font-weight-500 no-border" *ngFor="let head of dtOptions.columns">{{head.title}}</th>
        </tr>
      </thead>
      <tbody #tableBody>
      </tbody>
      <tfoot>                            
      </tfoot>
  </table>
</div>